import React from 'react';
import { CoobyVmSettings } from '../organisms';
import { SettingsTemplate } from '../templates';

export function CoobyVmPage() {
  return (
    <SettingsTemplate>
      <CoobyVmSettings />
    </SettingsTemplate>
  );
}
